// extracted by mini-css-extract-plugin
export default {"loader":"LoadingIcon_loader__ubJqg","spinner":"LoadingIcon_spinner__7fFeE"};